import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import Box from '../Styled/Box';

const StyledCard = styled(Box)`
  ${({ overflow }) => overflow && `
      &::-webkit-scrollbar-track {
        background: #FFFFFF;
      }
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #CDD2DB;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #A6AEBA;
    }
  `}
`;

const Card = ({
  children,
  theme,
  overflow,
  ...props
}) => (
  <StyledCard
    borderRadius={12}
    padding={4}
    backgroundColor='coldgrey100'
    boxShadow={theme.shadows.light[2]}
    border={`solid 1px ${theme.colors.coldgrey300}`}
    overflow={overflow}
    {...props}
  >
    {children}
  </StyledCard>
);

Card.propTypes = {
  theme: PropTypes.object.isRequired,
  overflow: PropTypes.string,
  children: PropTypes.any,
};

Card.defaultProps = {
  children: null,
  overflow: 'hidden',
};

export default withTheme(Card);
